import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
    roles: string[];
    setRoles: (roles: string[]) => void;
    clearRoles: () => void;
}

export const useAuthServiceStore = create<AuthState>()(
    persist(
        (set) => ({
            roles: [],

            setRoles: (roles) =>
                set({
                    roles,
                }),

            clearRoles: () =>
                set({
                    roles: [],
                }),
        }),
        {
            name: 'auth-service-storage',
        }
    )
);